export enum ECountryCode {
  GLOBAL = "global",
}
